import { render, staticRenderFns } from "./usersRegistered.vue?vue&type=template&id=c530dc4c"
import script from "./usersRegistered.vue?vue&type=script&lang=js"
export * from "./usersRegistered.vue?vue&type=script&lang=js"
import style0 from "./usersRegistered.vue?vue&type=style&index=0&id=c530dc4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports